import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useHiringProcess } from '../../context/HiringProcessContext';
import { auth } from '../../firebaseConfig';

function Page1_Landing() {
  const { jobTitle, setJobTitle, setStep } = useHiringProcess();
  const navigate = useNavigate();
  const user = auth.currentUser;

  const handleStart = () => {
    if (jobTitle.trim() === '') {
      // Maybe show a notification
      return;
    }
    setStep(2);
    navigate('/start-hiring/description');
  };

  return (
    <div className="li-card" style={{ padding: '32px', textAlign: 'center' }}>
      <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '16px', color: 'rgba(0,0,0,0.9)' }}>
        Start New Hiring Project
      </h2>
      <p style={{ fontSize: '16px', color: 'rgba(0,0,0,0.6)', maxWidth: '500px', margin: '0 auto 32px', lineHeight: '1.5' }}>
        Our AI-driven simulations will help you discover the best talent. Start by giving your new role a title.
      </p>
      
      <div style={{ textAlign: 'left', maxWidth: '500px', margin: '0 auto' }}>
        <label htmlFor="jobTitle" style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: 'rgba(0,0,0,0.7)', marginBottom: '4px' }}>
          Job Title
        </label>
        <input
          type="text"
          id="jobTitle"
          className="li-input"
          placeholder="e.g., Senior Platform Engineer"
          value={jobTitle}
          onChange={(e) => setJobTitle(e.target.value)}
          style={{ width: '100%', marginBottom: '24px' }}
        />
        <button onClick={handleStart} className="li-btn-primary" style={{ width: '100%', padding: '12px', fontSize: '16px' }}>
          Start
        </button>
      </div>
    </div>
  );
}

export default Page1_Landing;
